import { Box } from '@mui/material'
import { useIntl } from 'react-intl'
import { useAppSelector } from '../../../app/hooks'
import { useGetCountriesQuery } from '../../../app/redux-fetch/apiCoreQuery'
import {
  useGetAllInventoryUnitsQuery,
  useGetProductCategoriesQuery,
} from '../../../app/redux-fetch/apiProducts'
import { useGetCustomersQuery } from '../../../app/redux-fetch/apiQuery'
import { IDropDownItem } from '../../../app/types'
import FormInput from '../../../components/Forms/FormInput'
import FormSelect, { Option } from '../../../components/Forms/FormSelect'
import { SectionTitleTypography } from '../../../components/Typographies/styles'
import { fetchLoggedInUserSelector } from '../../selectors'
import { ILoggedInUser } from '../../types'
import messages from './messages'

type MainInfoProps = {
  isDisabled?: boolean
  customerId?: number
}

const MainInfo = ({ isDisabled = false, customerId: sharedCustomerId = -1 }: MainInfoProps) => {
  const { formatMessage } = useIntl()
  const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)

  const { data: countries = [] } = useGetCountriesQuery()
  const { data: inventoryUnits = [] } = useGetAllInventoryUnitsQuery()

  const { data: customers } = useGetCustomersQuery(loggedInUser.tenantId ?? -1)

  const isCustomerUser = sharedCustomerId > 0

  const { data: productCategories = [] } = useGetProductCategoriesQuery({
    tenantId: loggedInUser.tenantId ?? -1,
    customerId: sharedCustomerId,
  })



  const mapToOptions = (items: any[] = []): Option[] => {
    if (!Array.isArray(items)) return []
    return items.map((item) => ({
      label: item.name || '',
      value: item.id || 0,
    }))
  }

  return (
    <Box sx={{ width: '50%', mt: '16px' }}>
      <Box sx={{ mb: '16px' }}>
        <SectionTitleTypography>{formatMessage(messages.mainInfoLbl)}</SectionTitleTypography>
      </Box>
      {!isCustomerUser && (
        <Box sx={{ mb: '8px' }}>
          <FormSelect
            name='customerId'
            label={formatMessage(messages.customerLbl)}
            options={mapToOptions((customers as IDropDownItem[]) || [])}
            disabled
            required
          />
        </Box>
      )}
      <Box sx={{ mb: '8px' }}>
        <FormInput
          name='sku'
          label={formatMessage(messages.productCode)}
          disabled={isDisabled}
          required
          maxLength={50}
          inputPattern={/[^a-zA-Z0-9\-_.#,]/g}
        />
      </Box>
      <Box sx={{ mb: '8px' }}>
        <FormInput
          name='name'
          label={formatMessage(messages.productName)}
          disabled={isDisabled}
          required
          maxLength={250}
        />
      </Box>
      <Box sx={{ mb: '8px' }}>
        <FormSelect
          name='productCategoryId'
          label={formatMessage(messages.productCategory)}
          options={mapToOptions(productCategories as IDropDownItem[])}
          disabled={isDisabled}
          required
        />
      </Box>
      <Box sx={{ mb: '8px' }}>
        <FormSelect
          name='countryOfOriginId'
          label={formatMessage(messages.countryOfOrigin)}
          options={mapToOptions(countries as any)}
          disabled={isDisabled}
          required
        />
      </Box>
      <Box sx={{ mb: '8px' }}>
        <FormSelect
          name='inventoryUnitId'
          label={formatMessage(messages.inventoryUnit)}
          options={mapToOptions(inventoryUnits as any)}
          disabled={isDisabled}
          required
        />
      </Box>
      <Box sx={{ mb: '8px' }}>
        <FormInput
          name='barcode'
          label={formatMessage(messages.barcode)}
          disabled={isDisabled}
          maxLength={50}
          inputPattern={/[^a-zA-Z0-9]/g}
        />
      </Box>
    </Box>
  )
}

export default MainInfo
